import React, { Suspense } from "react";
import { Redirect, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import AuthenticatedLayout from "./AuthenticatedLayout";
import { PageLoadingVeil } from "../ui/composites/page-loading-veil";

/**
 * Single persistent shell for all authenticated routes.
 * TopBar + Sidebar stay mounted; only the inner Switch content swaps.
 */
export default function AuthenticatedShell({ children }) {
  const token = useSelector((state) => state.auth.token);
  const location = useLocation();

  if (!token) {
    return <Redirect to={{ pathname: "/login", state: { from: location } }} />;
  }

  return (
    <AuthenticatedLayout>
      <Suspense fallback={<PageLoadingVeil compact className="relative min-h-[12rem]" />}>
        {children}
      </Suspense>
    </AuthenticatedLayout>
  );
}
